import React, { useEffect, useMemo, useRef, useState } from "react";
import ImageLinks from "../../assets/Images/ImagesLink";
import _ from "lodash";
import api_requests from "../../resources/api_requests";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import qs from "qs";
import {
  ArrowRightFilledCircle,
  ClockIcon,
  CrossCircleFilled,
} from "../../assets/whiteLabelIcon";
import Footer from "../../Footer";
import OrderTrackListItem from "./OrderTrackListItem";
import OrderTrackListItemContentLoader from "./OrderTrackListItemContentLoader";
import { useTranslation } from "react-i18next";

const OrderTrackList = () => {
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const serach_param = [
    { title: t("customer_number"), value: "customer_mobile" },
    { title: t("order_id"), value: "order_id" },
  ];

  const tab_list = [
    { title: t("pre_pickup"), value: "OUT_FOR_PICKUP" },
    { title: t("on_delivery"), value: "OUT_FOR_DELIVERY" },
  ];

  let { tab } = qs.parse(location.search.slice(1));
  const [selected_search, set_selected_search] = useState("customer_mobile");
  const [selected_tab, set_selected_tab] = useState(
    tab ? tab : "OUT_FOR_PICKUP",
  );
  const [orders, set_orders] = React.useState({});
  const [order_list, set_order_list] = useState([]);
  const [input_val, set_input_val] = useState("");
  const [show_completed, set_show_completed] = useState(tab === "COMPLETED");
  const [is_result_filtered, set_is_result_filtered] = useState(false);
  const slider_ref = useRef();
  const loading_scroll = useRef(false);

  useEffect(() => {
    get_orders({});
  }, [selected_tab, show_completed]);

  const get_orders = async ({ token, limit = 20 }, from_clear = false) => {
    const previousScrollTop = slider_ref.current?.scrollTop;
    set_orders({ next: true });
    const filter_object = {
      ...(!_.isEmpty(input_val) &&
        !from_clear && { [selected_search]: input_val }),
    };
    set_is_result_filtered(!_.isEmpty(filter_object));

    let local_order_list = [];
    try {
      setLoading(true);
      const res = await api_requests.get_orders_list({
        ...filter_object,
        ...(token && { token }),
        limit: show_completed ? 50 : limit,
        group: show_completed
          ? "completed"
          : selected_tab == "OUT_FOR_PICKUP"
            ? "ready_to_ship"
            : "shipped",
        created_at:
          moment().subtract("15", "days").format("YYYY-MM-DD") +
          "," +
          moment().format("YYYY-MM-DD"),
      });

      local_order_list = _.cloneDeep(res.data.items);

      if (show_completed) {
        const res2 = await api_requests.get_orders_list({
          limit: 50,
          status: 0,
          created_at:
            moment().subtract("15", "days").format("YYYY-MM-DD") +
            "," +
            moment().format("YYYY-MM-DD"),
        });
        local_order_list = _.concat(local_order_list, res2.data.items);
      }
      const sorted_data = _.orderBy(local_order_list, ["updated_at"], ["desc"]);

      set_orders(res.data);
      set_order_list(token ? _.concat(order_list, sorted_data) : sorted_data);
      setLoading(false);
    } catch (error) {
      loading_scroll.current = false;
      setLoading(false);
    } finally {
      loading_scroll.current = false;
      if (slider_ref.current) {
        slider_ref.current.scrollTop = previousScrollTop;
      }
      setLoading(false);
    }
  };

  const slider_scrolled = () => {
    if (
      slider_ref.current.scrollTop + slider_ref.current.clientHeight + 100 >=
        slider_ref.current.scrollHeight &&
      orders.next &&
      !loading_scroll.current
    ) {
      loading_scroll.current = true;
      get_orders({ token: orders.next });
    }
  };

  const handle_search = () => {
    if (_.isEmpty(input_val)) return;
    get_orders({});
  };

  const handle_clear_filter = () => {
    set_input_val("");
    get_orders({}, true);
  };

  const handle_back_press = () => {
    navigate(-1);
  };

  const handle_input = (e) => {
    if (selected_search == "customer_mobile") {
      if (e.target.value.length > 10) return;
    }
    set_input_val(e.target.value);
  };

  const upper_circle_class = useMemo(() => {
    return selected_tab === show_completed
      ? "bg-dark_green"
      : selected_tab === "OUT_FOR_PICKUP"
        ? "bg-pink"
        : "bg-dark_green";
  }, [selected_tab]);

  const inner_circle_class = useMemo(() => {
    return show_completed
      ? "bg-dark_green"
      : selected_tab === "OUT_FOR_PICKUP"
        ? "bg-light_pink2"
        : "bg-light_green";
  }, [selected_tab]);

  const vertical_line_class = useMemo(() => {
    return show_completed
      ? "bg-light_green"
      : selected_tab === "OUT_FOR_PICKUP"
        ? "bg-light_pink2"
        : "bg-light_green";
  }, [selected_tab]);

  const null_text = useMemo(() => {
    let text = "";
    if (input_val == "") {
      text =
        selected_tab === "OUT_FOR_PICKUP"
          ? t("looks_like_you_dont_have_any_order_out_for_pickup")
          : selected_tab === "OUT_FOR_DELIVERY"
            ? t("looks_like_you_dont_have_any_order_out_for_delivery")
            : t("looks_like_you_dont_have_any_completed_orders");
    } else {
      text =
        selected_search === "customer_mobile" ? (
          <>
            {t("cant_find_any_order")}{" "}
            {t("kindly_check_the_contact_number_and_try_again")}.
          </>
        ) : selected_search === "ref_id" ? (
          <>
            {t("cant_find_any_order")}{" "}
            {t("kindly_check_the_ref_id_and_try_again")}.
          </>
        ) : (
          <>
            {t("cant_find_any_order")}{" "}
            {t("kindly_check_the_order_id_and_try_again")}.
          </>
        );
    }
    return text;
  }, [order_list]);

  return (
    <div className="min-h-screen px-6 py-5 overflow-hidden h-[100vh]">
      <header className="flex items-center mb-6" onClick={handle_back_press}>
        <img src={ImageLinks.chevron_left} />
        <button className="font-custom text-sm font-semibold ml-2">
          {show_completed ? t("completed_orders") : t("track_packages")}
        </button>
      </header>

      <div className="flex justify-between mb-5 ml-6">
        <div>
          <h2 className="font-custom font-medium text-xs text-dark_gray">
            {t("total_packages")}
          </h2>
          <p className="font-custom font-semibold text-xl">
            {order_list.length}
            {/* {show_completed
              ? order_stats?.completed
              : selected_tab === "OUT_FOR_PICKUP"
              ? order_stats?.out_for_pickup
              : order_stats?.out_for_delivery} */}
          </p>
        </div>
        <button
          className="text-blue-500 flex items-center gap-1"
          onClick={() => {
            const curr_val = show_completed;
            set_show_completed((prev) => !prev);
            set_selected_tab(curr_val ? "OUT_FOR_PICKUP" : null);
          }}
        >
          <ClockIcon />
          <p className="font-custom font-semibold text-xs text-secondary">
            {show_completed ? t("track_packages") : t("completed_orders")}
          </p>
        </button>
      </div>

      <div
        className="mb-4 px-8 py-5 rounded-lg"
        style={{ boxShadow: `0px 0px 8px 0px #A6A6A640` }}
      >
        <div className="flex gap-2 mb-2">
          {_.map(serach_param, (item, index) => (
            <button
              key={`search_item-${index}`}
              className={`btn btn-outline ${
                item.value === selected_search
                  ? "border-secondary"
                  : "border-accents"
              } rounded-full btn-sm`}
              onClick={() => set_selected_search(item.value)}
            >
              <p
                className={`font-custom font-semibold ${
                  item.value === selected_search
                    ? "text-secondary"
                    : "text-accents"
                } text-[10px]`}
              >
                {item.title}
              </p>
            </button>
          ))}
        </div>
        <div
          className={`flex items-center border border-accents rounded-[30px]  px-4 py-2 bg-white mt-4`}
        >
          <input
            id="pac-input"
            type={`${selected_search === "order_id" ? "text" : "number"}`}
            placeholder={`${selected_search === "order_id" ? t("enter_order_id") : t("enter_phone_number")}`}
            className={`w-full text-gray-700 placeholder-gray-500 bg-transparent text-sm focus:outline-none`}
            onChange={handle_input}
            value={input_val}
          />
          <div
            style={{ opacity: _.isEmpty(input_val) ? 0.3 : 1 }}
            onClick={is_result_filtered ? handle_clear_filter : handle_search}
          >
            {is_result_filtered ? (
              <CrossCircleFilled />
            ) : (
              <ArrowRightFilledCircle />
            )}
          </div>
        </div>
      </div>

      {!show_completed && (
        <section className="mb-2 flex gap-8">
          {_.map(tab_list, (tab_item, tab_index) => (
            <div
              key={`tab_item${tab_index}`}
              className={`${
                tab_item?.value === selected_tab ? "border-b-2" : "border-b-0"
              } border-secondary pb-2 px-4`}
              onClick={() => set_selected_tab(tab_item?.value)}
            >
              <p
                className={`font-custom font-semibold ${
                  tab_item.value === selected_tab
                    ? "text-secondary"
                    : "text-accents"
                } text-sm`}
              >
                {tab_item.title}
              </p>
            </div>
          ))}
        </section>
      )}

      {!isLoading && _.isEmpty(order_list) ? (
        <div className="flex flex-col justify-center w-full p-10 items-center text-center h-[52vh]">
          <p className="font-custom text-xs font-medium text-dark_gray">
            {null_text}
          </p>
        </div>
      ) : (
        <div
          className="flex flex-col gap-2 overflow-auto p-2"
          ref={slider_ref}
          onScroll={slider_scrolled}
          style={{
            height: `calc(100vh -  ${
              !show_completed ? "347px" : "308px"
            } - env(safe-area-inset-bottom))`,
            paddingBottom: 60,
          }}
        >
          {isLoading ? (
            <>
              <OrderTrackListItemContentLoader />
              <OrderTrackListItemContentLoader />
              <OrderTrackListItemContentLoader />
            </>
          ) : (
            _.map(order_list, (item) => (
              <OrderTrackListItem
                key={`order_item_${item.id}`}
                item={item}
                selected_tab={selected_tab}
                show_completed={show_completed}
              />
            ))
          )}
        </div>
      )}
      <Footer bottom={0} />
    </div>
  );
};

export default OrderTrackList;
